import React from 'react';
import { InputGroup } from 'react-bootstrap';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export const ExclusiveSurface = ({ errors, touched }) => (
  <div>
    <label>Superficie exclusiva</label>
    <InputGroup size="sm" className="formWidths" style={{ maxWidth: '150px' }}>
      <InputGroup.Text id="basic-addon1">m2</InputGroup.Text>
      <Field className="form-control" name="surface.exclusiveSurface" />
    </InputGroup>
    {errors.surface?.exclusiveSurface && touched.surface?.exclusiveSurface && (
      <label className="w-100 text-danger mt-1">
        {errors.surface.exclusiveSurface}
      </label>
    )}
  </div>
);

ExclusiveSurface.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object
};
